'use client'

import { isObjectPage } from '@/services/pathname'
import { ReactNode, useId, useEffect, useRef, useState } from 'react'
import { object, z } from 'zod'
import { messages } from '@/services/validation'
import { status as s } from '@/services/status'
import { initRecaptcha } from '@/services/recaptcha/client'
import { checkRecaptcha } from '@/services/recaptcha/server'
import { postSharing } from '@/api/actions'
import Loading from '@/components/loading/Preloader'
import { getName } from '@/services/aroeven'
import moment from 'moment'

type TemporaryNoticeProps = {
    aroeven: Aroeven
}

export default function TemporaryNotice({
    aroeven
}: TemporaryNoticeProps) {

    return null

    const id = useId().replaceAll(':', '')
    const refModal = useRef(null)
    const [status, setStatus] = useState<string>(s.idle)
    const [errors, setErrors] = useState([])

    useEffect(() => {
        console.log('uef effect notice')
        async function load() {
            const bootstrap = (await import('bootstrap/dist/js/bootstrap')).default;
            refModal.current = new bootstrap.Modal(document.getElementById(id + '-modal'))
            refModal.current.show()
        }
        load()
    }, [])

    return (
        <>
            <div className="modal fade" id={id + '-modal'} tabIndex={-1} role="dialog" aria-labelledby={id + '-button'} aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content border-0">
                        <div className="modal-header modal-colored-header bg-primary text-white">
                            <h4 className="modal-title text-white" id="primary-header-modalLabel">Les Aroéven ont besoin de vous</h4>
                            <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="card-body p-3">
                                <h4 className="text-danger">Ne laissons pas la France fermer la porte aux vacances de nos enfants !</h4>
                                <p className='text-dark'>
                                    La Fédération des Aroéven, aux côtés des citoyens, organisations, collectivités, CSE, demandons au gouvernement de cesser de sacrifier ce droit fondamental et de reléguer la jeunesse au dernier plan, en :
                                    <ul className='ms-3'>
                                        <li>- reconnaissant pleinement le droit aux vacances comme un droit fondamental de l’enfant, au même titre que l’éducation et la santé,</li>
                                        <li>- maintenant et renforçant des politiques publiques pour les colos, les camps de scoutisme et les séjours éducatifs,</li>
                                        <li>- soutenant les familles et les structures qui rendent ces départs possibles.</li>
                                    </ul>                                    
                                </p>
                                <p className='text-dark'>
                                    Signez pour dire NON à une France qui ferme la porte aux vacances des enfants !
                                </p>
                                <p className='d-flex justify-content-center'>
                                    <a className="button-primary" href="https://www.change.org/p/ne-laissons-pas-la-france-fermer-la-porte-aux-vacances-de-nos-enfants?recruiter=1395359240&recruited_by_id=b6259ab0-c080-11f0-a838-e9f7827f1d6e&utm_source=share_petition&utm_campaign=share_petition&utm_term=petition_dashboard&utm_medium=copylink&utm_content=cl_sharecopy_490888709_fr-FR%3A7" target="_blank">Signer la pétition</a>
                                </p>
                                <p className='d-flex justify-content-center'>
                                    <a href="https://www.change.org/p/ne-laissons-pas-la-france-fermer-la-porte-aux-vacances-de-nos-enfants?recruiter=1395359240&recruited_by_id=b6259ab0-c080-11f0-a838-e9f7827f1d6e&utm_source=share_petition&utm_campaign=share_petition&utm_term=petition_dashboard&utm_medium=copylink&utm_content=cl_sharecopy_490888709_fr-FR%3A7" target='_blank'><img src="https://assets.change.org/photos/6/aw/ub/LFAwubqOGoEiDCG-800x450-noPad.jpg" /></a>
                                </p>
                            </div>
                        </div>
                        <div className="modal-footer pt-0 pe-4">
                            <button className="button-outline" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

